const regionesChile = {
  "regiones": [
    {
      "region": "Arica y Parinacota",
      "comunas": ["Arica", "Camarones", "Putre", "General Lagos"],
      "tiendas": []  
    },
    {
      "region": "Tarapacá",
      "comunas": ["Iquique", "Alto Hospicio", "Pozo Almonte", "Camiña", "Colchane", "Huara", "Pica"],
      "tiendas": []  
    },
    {
      "region": "Antofagasta",
      "comunas": ["Antofagasta", "Mejillones", "Sierra Gorda", "Taltal", "Calama", "Ollagüe", "San Pedro de Atacama", "Tocopilla", "María Elena"],
      "tiendas": [
        {
          nombre: "SERVITEC TRUJILLO",
          direccion: "14 de Febrero 2241, Antofagasta",
          id: "tienda-servitec-trujillo"
        }
      ]  
    },
    {
        "region": "Atacama",
        "comunas": ["Copiapó", "Caldera", "Tierra Amarilla", "Chañaral", "Diego de Almagro", "Vallenar", "Alto del Carmen", "Freirina", "Huasco"],
        "tiendas": [] 
    },
    {
      "region": "Coquimbo",
      "comunas": ["La Serena", "Coquimbo", "Ovalle", "Illapel"],
      "tiendas": []
    },
    {
      "region": "Metropolitana",
      "comunas": ["Cerrillos", "Cerro Navia", "Conchalí", "El Bosque", "Estación Central", "Huechuraba", "Independencia", "La Cisterna", "La Florida", "La Granja", "La Pintana", "La Reina", "Las Condes", "Lo Barnechea", "Lo Espejo", "Lo Prado", "Macul", "Maipú", "Ñuñoa", "Pedro Aguirre Cerda", "Peñalolén", "Providencia", "Pudahuel", "Quilicura", "Quinta Normal", "Recoleta", "Renca", "Santiago", "San Joaquín", "San Miguel", "San Ramón", "Vitacura", "Puente Alto", "Pirque", "San José de Maipo", "Colina", "Lampa", "Tiltil", "San Bernardo", "Buin", "Calera de Tango", "Paine", "Melipilla", "Alhué", "Curacaví", "María Pinto", "San Pedro", "Talagante", "El Monte", "Isla de Maipo", "Padre Hurtado", "Peñaflor"],
      "tiendas": [
        {
          nombre: "Sucursal Thorben Servicio al Cliente",
          direccion: "Francisco Bilbao 0166, local 10, Providencia",
          id: "tienda-sucursal-thorben"
        },
        {
          nombre: "SERVICIO TÉCNICO",
          direccion: "Cordillera 101, Quilicura, Santiago",
          id: "tienda-servicio-tecnico-frato"
        }
      ]
    },
    {
      "region": "Valparaiso",
            "comunas": ["Valparaíso", "Casablanca", "Concón", "Juan Fernández", "Puchuncaví", "Quintero", "Viña del Mar", "Isla de Pascua", "Los Andes", "Calle Larga", "Rinconada", "San Esteban", "La Ligua", "Cabildo", "Papudo", "Petorca", "Zapallar", "Quillota", "Calera", "Hijuelas", "La Cruz", "Nogales", "San Antonio", "Algarrobo", "Cartagena", "El Quisco", "El Tabo", "Santo Domingo", "San Felipe", "Catemu", "Llaillay", "Panquehue", "Putaendo", "Santa María", "Quilpué", "Limache", "Olmué", "Villa Alemana"],
      "tiendas": []
    },
     {
        "region": "Libertador Gral. Bernardo O'Higgins",
        "comunas": ["Rancagua", "Codegua", "Coinco", "Coltauco", "Doñihue", "Graneros", "Las Cabras", "Machalí", "Malloa", "Mostazal", "Olivar", "Peumo", "Pichidegua", "Quinta de Tilcoco", "Rengo", "Requínoa", "San Vicente", "Pichilemu", "La Estrella", "Litueche", "Marchihue", "Navidad", "Paredones", "San Fernando", "Chépica", "Chimbarongo", "Lolol", "Nancagua", "Palmilla", "Peralillo", "Placilla", "Pumanque", "Santa Cruz"],
        "tiendas": [] 
    },
    {
        "region": "Maule",
        "comunas": ["Talca", "Constitución", "Curepto", "Empedrado", "Maule", "Pelarco", "Pencahue", "Río Claro", "San Clemente", "San Rafael", "Cauquenes", "Chanco", "Pelluhue", "Curicó", "Hualañé", "Licantén", "Molina", "Rauco", "Romeral", "Sagrada Familia", "Teno", "Vichuquén", "Linares", "Colbún", "Longaví", "Parral", "Retiro", "San Javier", "Villa Alegre", "Yerbas Buenas"],
        "tiendas": [
          {
            nombre: "MULTISERVICIOS SAN PEDRO",
            direccion: "Av.Carlos Condell 1192, Curicó (Local Multiservicios interior Homecenter Sodimac)",
            id: "tienda-multiservicios-san-pedro"
          }
        ] 
    },
    {
        "region": "Ñuble",
        "comunas": ["Cobquecura", "Coelemu", "Ninhue", "Portezuelo", "Quirihue", "Ránquil", "Treguaco", "Bulnes", "Chillán Viejo", "Chillán", "El Carmen", "Pemuco", "Pinto", "Quillón", "San Ignacio", "Yungay", "Coihueco", "Ñiquén", "San Carlos", "San Fabián", "San Nicolás"],
        "tiendas": [] 
    },
    {
      "region": "Biobio",
      "comunas": ["Concepción", "San Pedro de la Paz", "Chiguayante", "Talcahuano"],
      "tiendas": [
        {
          nombre: "DIGICOM",
          direccion: "Calle Central 2553 sector San Martin, Comuna de Chiguayante",
          id: "tienda-digicom"
        },
        {
          nombre: "Servicio Técnico Autorizado, San Andrés",
          direccion: "San Martín 461, Los Ángeles",
          id: "tienda-servicio-tecnico-san-andres"
        }
      ]
    },
    {
      "region": "Araucania",
      "comunas": ["Temuco", "Padre Las Casas", "Villarrica", "Pucón"],
      "tiendas": [
        {
          nombre: "Electrónica Pehuen",
          direccion: "Calle Carrera 225, entre Lautaro y Rodríguez. Ref: A 2 cuadras del Hospital Regional - Casco Centro.",
          id: "tienda-electronica-pehuen"
        }
      ]
    },
    {
        "region": "Los Ríos",
        "comunas": ["Valdivia", "Corral", "Lanco", "Los Lagos", "Máfil", "Mariquina", "Paillaco", "Panguipulli", "La Unión", "Futrono", "Lago Ranco", "Río Bueno"],
        "tiendas": [] 
    },
    {
        "region": "Los Lagos",
        "comunas": ["Puerto Montt", "Calbuco", "Cochamó", "Fresia", "Frutillar", "Los Muermos", "Llanquihue", "Maullín", "Puerto Varas", "Castro", "Ancud", "Chonchi", "Curaco de Vélez", "Dalcahue", "Puqueldón", "Queilén", "Quellón", "Quemchi", "Quinchao", "Osorno", "Puerto Octay", "Purranque", "Puyehue", "Río Negro", "San Juan de la Costa", "San Pablo", "Chaitén", "Futaleufú", "Hualaihué", "Palena"],
        "tiendas": [
          {
            nombre: "Servicio Técnico del Sur Spa",
            direccion: "Los Castaños 389, Purranque, Osorno",
            id: "tienda-servicio-tecnico-del-sur"
          },
          {
            nombre: "SAT SAN JAVIER",
            direccion: "Ecuador 1162, Puerto Montt",
            id: "tienda-sat-san-javier"
          }
        ] 
    },
    {
        "region": "Aisén del Gral. Carlos Ibáñez del Campo",
        "comunas": ["Coihaique", "Lago Verde", "Aisén", "Cisnes", "Guaitecas", "Cochrane", "O'Higgins", "Tortel", "Chile Chico", "Río Ibáñez"],
        "tiendas": [] 
    },
    {
        "region": "Magallanes y de la Antártica Chilena",
        "comunas": ["Punta Arenas", "Laguna Blanca", "Río Verde", "San Gregorio", "Cabo de Hornos (Ex Navarino)", "Antártica", "Porvenir", "Primavera", "Timaukel", "Natales", "Torres del Paine"],
        "tiendas": [
          {
            nombre: "Electronica MT",
            direccion: "Belisario Garcia Nº0781 Pobl. Cecil Rasmussen, Punta Arenas",
            id: "tienda-electronica-mt"
          }
        ] 
    }
  ]
};